export default __webpack_public_path__ + "static/media/landslide.99d0e490.svg";